export enum DeviceType {
  Awair = 'awair',
  Glow = 'awair-glow',
  Omni = 'awair-omni',
  Mint = 'awair-mint',
  Rev2 = 'awair-r2',
  'awair' = 'Awair',
  'awair-glow' = 'Glow',
  'awair-omni' = 'Omni',
  'awair-mint' = 'Mint',
  'awair-r2' = 'Rev2'
}
